import { http } from "./client";

export const getIncidents = (medicaidid) => http.get('Incidents',{params: {medicaidid: medicaidid}});
export const getIncident = (id) => http.get('Incidents/get',{params: {Id : id}});
export const getIncidentDefinitions = () => http.get('Incidents/definitions');
export const incidentInitialUpsert = (payload) => http.post('Incidents/upsertprimary',payload);
export const incidentFollowupUpsert = (payload) => http.post('Incidents/upsertfollowup',payload);
export const incidentFollowupStaffUpsert = (payload) => http.post('Incidents/upsertfollowupstaff',payload);
export const incidentFollowupResponseUpsert = (payload) => http.post('Incidents/upsertresponsetofollowup',payload);